__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-travel-advisory'].baseUrl;
import ModuleContainer from './components/TravelAdvisory';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/one-app-module-wrapper': '^3.4.2',
      '@americanexpress/travel-selectors': '^5.0.0',
      'react-intl': '^6.3.2'
    }
  });
}